import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { backTarget, canGoBack } from "../utils/backNavigation";

/**
 * "Back to cases", shown only when there is a back to go to.
 *
 * A case opened in a new tab renders nothing: that tab's history starts here,
 * so the control would be a lie. One opened from the list returns to the list
 * it came from, which the list records when it links — so a property case
 * goes back to the property list, and a redesign case to the redesigned one
 * rather than into the old design.
 */
export default function BackToCases({ label = "Back to cases", className = "" }) {
  const location = useLocation();
  const navigate = useNavigate();

  if (!canGoBack(location)) return null;

  const target = backTarget(location);
  return (
    <button
      type="button"
      onClick={() => (target ? navigate(target) : navigate(-1))}
      className={`inline-flex items-center gap-2 rounded-control border border-cl-control bg-cl-surface px-[11px] py-[6px] text-[12.5px] font-medium text-cl-secondary transition-colors hover:bg-cl-hover hover:text-cl-text ${className}`}
    >
      <ArrowLeft className="h-[14px] w-[14px]" />
      {label}
    </button>
  );
}
